<template>
  <WsRead
    :modelName="modelName"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    titleKey="name"
    :deletable="false"
    :customBtns="_customBtns"
    @importSubscribeActList="$_onImportSubscribeActList()"
    @input="$_getModelData"
    @copy-factory="$_onCopyFactory"
  >
    <input
      v-show="false"
      ref="fileInput"
      type="file"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      @change="$_onFileChange($event)"
    >
    <WsDialog
      v-model="isDialogShow"
      class="pb-2"
      ref="WsDialog"
      @close="$_onCloseDialog()"
      :title="`以下為匯入檔案中 '找不到符合現有法規名稱' 的法規清單`"
    >
      <template v-slot:content>
        <VDataTable
          :items="mappingFailActList"
          :items-per-page="-1"
          :headers="headers"
          hide-default-footer
        />
      </template>
      <template v-slot:rightActions>
        <WsBtn
          @click="$_onCloseDialog()"
          minWidth="100px"
          :loading="false"
          color="primary"
        >取消</WsBtn>
      </template>
    </WsDialog>
  </WsRead>
</template>

<script>
import model from '@/models/factory';

export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    localeMode: true,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              fields: [
                "locales.name",
                "factory",
                "register_number",
                "uniform_number",
                "remark",
                "attaches",
                "max_member_count",
                "subscriptions",
                "address",
                "administrator_name",
                "administrator_email",
                "administrator_password_updated_at",
                "access_token",
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "工廠季度",
              fields: [
                "custom_season_month_q1",
                "custom_season_month_q2",
                "custom_season_month_q3",
                "custom_season_month_q4",
              ],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: [
                "area",
                "industry_categories",
                "start_date",
                "due_date",
                "app",
                "type",
                "subscription_api_modules",
                "is_image_viewable",
                'map_url',
                'is_alliance_home_page',
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "訂閱設定",
              fields: [
                "subscription_areas",
                "subscription_industry_categories",
                "system_classes",
                "system_subclasses",
                "subscription_topic",
                "subscription_locales",
                "subscription_alliances",
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "建立資訊",
              fields: ["created_admin", "created_at"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "編輯資訊",
              fields: ["updated_admin", "updated_at"],
            },
          ],
        },
        {
          type: "activeSwitch",
          title: "開通設定",
          remark: "停用的內容將不會顯示於使用者前台介面",
          field: "status",
          extendPatchData(data) {
            return { address: data.address };
          },
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "標籤設定",
              remark: "標籤僅供後台檢索，不影響前台使用",
              fields: ["tags"],
            },
          ],
        },
      ],
    },
    isDialogShow: false,
    mappingFailActList: [],
    headers: [
      {
        value: 'name',
        text: '法規名稱',
        width: '300px',
      }
    ],
    modelData: {},
  }),
  computed: {
    _currentFactoryId() {
      return this.$route.params.id
    },
    _customBtns() {
      const customBtns = [
        {
          title: `查看訂閱法規清單`,
          color: 'textSecondary',
          outlined: true,
          icon: 'mdi-gavel',
          to: `/factory/${this._currentFactoryId}/subscribe_act`
        },
        {
          title: `匯入訂閱法規清單`,
          color: 'textSecondary',
          outlined: true,
          icon: 'mdi-paperclip',
          emit: 'importSubscribeActList',
        },
        {
          title: `複製`,
          color: 'textSecondary',
          outlined: true,
          icon: 'mdi-content-copy',
          emit: 'copy-factory',
        },
      ];
      if (this.modelData.type === 'subscription-api') customBtns.push({
        title: `查看同步API紀錄`,
        color: 'textSecondary',
        outlined: true,
        icon: 'mdi-book-open-variant',
        to: `/factory/${this._currentFactoryId}/sync_api`,
      });
      return customBtns;
    }
  },
  methods: {
    $_onImportSubscribeActList() {
      this.$refs.fileInput.click()
    },
    async $_onFileChange($event) {
      const file = $event.target.files[0]
      const formData = new FormData()
      formData.append("file", file)
      const postUrl = `/factory/${this._currentFactoryId}/import/subscription_act`;
      try {
        const res = await this.$axios.post(postUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        this.mappingFailActList = res.data.data.map(data => {
          return {
            name: data,
          }
        })
        if (this.mappingFailActList.length) {
          this.$_onOpenDialog()
        }
      } catch (error) {
        alert('匯入發生錯誤，請檢查上傳檔案是否符合選項');
      }
    },
    $_onOpenDialog() {
      this.isDialogShow = true
    },
    $_onCloseDialog() {
      this.isDialogShow = false
    },
    $_getModelData($event) {
      this.modelData = $event;
    },
    $_onCopyFactory() {
      this.$router.push(`/factory/${this._currentFactoryId}/copy`);
    }
  }
};
</script>